export default class CoreConstants {
}
CoreConstants.Products = {
    VIDEO_ANALYTICS: 'videoAnalytics',
    PRO_BALANCER: 'proBalancer'
};
